import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import *  as $ from 'jquery';
import { Subject } from 'rxjs';

/// idiomas
import {TranslateService} from '@ngx-translate/core';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { AuthService } from 'app/auth/auth.service';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-employees',
  templateUrl: './update-employees.component.html',
  styleUrls: ['./update-employees.component.scss'],
  animations   : fuseAnimations
})
export class UpdateEmployeesComponent implements OnInit {
  idEmpresa: string;
  idProducto: string;
  fechaprod:string;
  datosEmpresa = {
    idEmpresa: '',
    idProducto: '',
    fechaprod:''
  };

  menu:boolean=true;
  boton:boolean=false;
  ventana_ancho = $(window).width();

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private authService:AuthService,
    private activatedRoute : ActivatedRoute,
    private router: Router
  ) {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.activatedRoute.params.subscribe(params => {
      console.log(params);
      this.idEmpresa = params.id;
      this.idProducto = params.idprod;
      this.fechaprod=params.fechaprod;
      this.datosEmpresa.idEmpresa = params.id;
      this.datosEmpresa.idProducto = params.idprod;
      this.datosEmpresa.fechaprod = params.fechaprod;
    });
  }

  ngOnInit() {
  }

  regresarDetail(){
    this.router.navigate(['/companies/detail',this.idEmpresa]);
  }

  onResize(event) {
  event.target.innerWidth;
  if(event.target.innerWidth<1000){
  this.menu=false;
  this.boton=true;
  }
  else{
  this.menu=true;
  this.boton=false;
  }
  }

  detectScreen(){
      if(this.ventana_ancho<1000){
        this.menu=false;
        this.boton=true;
      }
      else{
        this.menu=true;
        this.boton=false;
      }
    }

}
